import { render, staticRenderFns } from "./TerminalRegionInput.vue?vue&type=template&id=5376f74d&"
import script from "./TerminalRegionInput.vue?vue&type=script&lang=js&"
export * from "./TerminalRegionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports